// @flow
import React from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'

const isMobile = window.innerWidth < 600

export class SegmentHeader extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      overlayed: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          this.state.overlayed ? 'segment-header overlayed' : 'segment-header'
        }
      >
        <img className='ui image fluid label' src={this.props.image} />

        <div className='ui container'>
          {this.props.caption !== null && (
            <figcaption className='ui container'>
              {this.props.caption}
            </figcaption>
          )}
          <h4>{this.props.part}</h4>
          <h3>{this.props.title}</h3>
        </div>

        <Waypoint
          onEnter={event => {
            this.setState({ overlayed: true })
          }}
          onLeave={event => {
            this.setState({ overlayed: false })
          }}
        />
      </div>
    )
  }
}
